// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-input.page-name .input-container input {
  width: 180px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/name.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd","sourcesContent":[".page-input.page-name .input-container input {\n  width: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
